module.exports = __webpack_public_path__ + "img/gal1.53d2b794.png";